import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { GenericNumberInput } from '../../components';
import { InputModel } from '../../models';
import { ValidationMessages } from '../../misc';
import { InputWithoutSource } from '../../componentTypes';


const UnderwritingYearInput: InputWithoutSource = ({ input }) => (
    <GenericNumberInput label={input.name} input={input} message={ValidationMessages.requiredInput(input.name)} />
);

UnderwritingYearInput.meta = {
    inputType: InputModel.name
};

export default observer(UnderwritingYearInput);
